module.exports = "/legacy/5ab1ad142fc2028154746ad4fde03c45.svg";